import { rangeClosed } from "./array-utils";

/**
 * Generates birth year options for pension calculators with a sliding window approach.
 * Both the oldest and youngest age groups shift forward each year automatically.
 *
 * @param currentYear - The current year (e.g., 2026)
 * @param oldestAge - Maximum age for the oldest person in the range (e.g., 69)
 * @param youngestAge - Minimum age for the youngest person in the range (e.g., 18)
 * @returns Array of birth years from oldest to youngest
 *
 * @example
 * // For Eläkearvio calculator in 2026 (ages 18-69)
 * getBirthYearOptions(2026, 69, 18)
 * // Returns: [1957, 1958, ..., 2007, 2008]
 *
 * @example
 * // For OVE calculator in 2026 (ages 18-66)
 * getBirthYearOptions(2026, 66, 18)
 * // Returns: [1960, 1961, ..., 2007, 2008]
 */
export function getBirthYearOptions(
  currentYear: number,
  oldestAge: number,
  youngestAge: number,
): Array<number> {
  const oldestBirthYear = currentYear - oldestAge;
  const youngestBirthYear = currentYear - youngestAge;

  return rangeClosed(oldestBirthYear, youngestBirthYear);
}
